var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "1050",
      "title": _vm.customerName
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('CustomerCommentPanel', {
    ref: "CustomerCommentPanel",
    attrs: {
      "customer": _vm.currentCustomer
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }